import React, { useEffect } from "react";
import "./SalesReport.css";
import { useDispatch, useSelector } from "react-redux";
import { ReadCookie } from "../../utils/readCookie";
import { Button, Spin } from "antd";
import { useLocation } from "react-router-dom";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";
import DamageRecieptReportHeader from "./DamageRecieptReportHeader/DamageRecieptReportHeader";
import DamageRecieptReportFooter from "./DamageRecieptReportFooter/DamageRecieptReportFooter";
import { getDamageRecieptReportPrint } from "../../redux/actions/damageRecieptReport.action";

const DamageRecieptReport = () => {
  TabTitle("Damage Reciept Report")
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const {
    damageReceiptReport,
  } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  let damage_header_id = query.get("damage_header_id");

  const data = damageReceiptReport && damageReceiptReport?.payload?.data;

  const values = {

    damage_header_id: damage_header_id,
  };

  useEffect(() => {
    dispatch(getDamageRecieptReportPrint(token, values));
  }, []);

  let sumAmount = damageReceiptReport?.payload?.data.reduce(function (
    previousValue,
    currentValue
  ) {
    return (previousValue += parseFloat(currentValue.amount));
  },
    0);

  const handlePrint = () => {
    const css = '@page { size: portrait; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };



  return (
    <div>
      {data ? (
        <div
          className="order_report_view"
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >

          <table>
            <div className="print-header-only" >
              <DamageRecieptReportHeader />
            </div>
            {/* <thead>
              <tr>
                <td>
                  <div>
                    <CreditMemoReportHeader />
                  </div>
                </td>
              </tr>
            </thead> */}
            {!damageReceiptReport.loading && (
              <div className="no-print" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "80px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            )}
            <tbody>
              <tr>
                <td>
                  <div className="content-block">
                    <div className="sales-report-Table-data">
                      <table className="sales-report-table">
                        <tbody>
                          <tr>
                            <td
                              className="font_weight"
                              style={{
                                width: "88px",
                                border: "none",
                                height: "30px",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Quantity
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Item
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "500px",
                                border: "none",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Description
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                textAlign: "right",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Rate
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                textAlign: "right",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Discount
                            </td>
                            <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                textAlign: "right",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Tax Amount
                            </td>
                            {/* <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                textAlign: "right",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Tax
                            </td> */}
                            <td
                              className="font_weight"
                              style={{
                                width: "110px",
                                border: "none",
                                textAlign: "right",
                                paddingRight: "5px",
                                backgroundColor: "rgb(184, 184, 184)",
                              }}
                            >
                              Amount
                            </td>
                          </tr>
                          {data?.map((size, index) => {
                            return (
                              <tr>
                                <td style={{ border: "none", height: "20px", }}>{numeral(size.quantity).format("0")}</td>
                                <td
                                  style={{
                                    marginLeft: "0",
                                    border: "none",
                                  }}
                                >
                                  {size.sku}
                                </td>
                                <td style={{ border: "none", }}>{size.description}</td>
                                {/* <td className="text-center pl-0">$ {size.rate && size.rate}</td> */}
                                <td style={{ border: "none", textAlign: "right", }}>${size.rate && size.rate}</td>
                                <td style={{ border: "none", textAlign: "right", }}>${size.discount && size.discount}</td>
                                <td style={{ border: "none", textAlign: "right", }}>${size.tax_amount && size.tax_amount}</td>
                                <td style={{ border: "none", textAlign: "right", paddingRight: "5px", }}>${size.amount && size.amount}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      <hr />
                    </div>
                  </div>
                  <table className="sales-report-table-total2">
                    <tbody>
                      <tr className="font_weight">
                        <td
                          style={{
                            width: "118px",
                            textAlign: "right",
                            paddingRight: "10px",
                            border: "none",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                          className="font_weight total_cell"
                        >
                          Total
                        </td>
                        <td
                          className="sum_cell_credit"
                          style={{
                            width: "150px",
                            border: "none",
                            textAlign: "right",
                            paddingRight: "5px",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                        >
                          ${sumAmount && numeral(sumAmount).format("00.00")}

                        </td>
                      </tr>
                      {/* <tr className="font_weight" >
                        <td
                          style={{
                            width: "118px",
                            textAlign: "right",
                            paddingRight: "10px",
                            border: "none",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                          className="font_weight total_cell"
                        >
                          Re-Stocking Fee
                        </td>
                        <td
                          className="sum_cell_credit"
                          style={{
                            width: "150px",
                            border: "none",
                            textAlign: "right",
                            paddingRight: "5px",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                        >
                          ${data && numeral(data[0].re_stock).format("0.00")}
                        </td>
                      </tr>
                      <tr className="font_weight" style={{ borderBottom: "1px solid" }}>
                        <td
                          style={{
                            width: "118px",
                            textAlign: "right",
                            paddingRight: "10px",
                            border: "none",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                          className="font_weight total_cell"
                        >
                          Return Label Fee
                        </td>
                        <td
                          className="sum_cell_credit"
                          style={{
                            width: "150px",
                            border: "none",
                            textAlign: "right",
                            paddingRight: "5px",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                        >
                          ${data && numeral(data[0].return_label_fee).format("0.00")}
                        </td>
                      </tr> */}
{console.log("data[0]", data[0])}
                      {/* <tr className="font_weight">
                        <td
                          style={{
                            width: "118px",
                            textAlign: "right",
                            paddingRight: "10px",
                            border: "none",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                          className="font_weight total_cell"
                        >
                          Net Total
                        </td>
                        <td
                          className="sum_cell_credit"
                          style={{
                            width: "150px",
                            border: "none",
                            textAlign: "right",
                            paddingRight: "5px",
                            backgroundColor: "rgb(184, 184, 184)"
                          }}
                        >
                          ${data && numeral(sumAmount - data[0].re_stock - data[0].return_label_fee).format("00.00")}
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td className="footer2">

                  <div className="sales-report-footer">
                    <DamageRecieptReportFooter />
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <div className="spin">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default DamageRecieptReport;
